import { useState } from "react";
import { Button, ModalUpload } from "expano-components";
import { toBase64 } from "utils/helpers";

const ImageField = ({ input, label, meta, currentUrl }) => {
  const [isOpen, setOpen] = useState(false);
  const [fileName, setFileName] = useState(null);

  const handleUpload = async (file) => {
    const data = await toBase64(file);
    input.onChange(data);
    input.onBlur();
    setFileName(file.name);
  };

  const handleRemove = () => {
    input.onChange("");
    input.onBlur();
    setFileName(null);
  };

  const preview = input.value || currentUrl;

  return (
    <>
      <div className="form-group">
        {label && <label className="label-form">{label}</label>}
        {input.value ? (
          <div>
            <div className="row">
              <p>{fileName}</p>
              <Button
                style={{ padding: 0, marginLeft: 5 }}
                type="delete-bin"
                onClick={handleRemove}
              />
            </div>
            {preview && (
              <img
                src={preview}
                alt="Podgląd etykiety"
                style={{ display: "block", maxWidth: 240, marginTop: 10 }}
              />
            )}
          </div>
        ) : (
          <>
            {currentUrl && (
              <img
                src={currentUrl}
                alt="Podgląd etykiety"
                style={{ display: "block", maxWidth: 240, marginBottom: 10 }}
              />
            )}
            <Button
              type="add"
              text="Wgraj podgląd etykiety"
              onClick={() => setOpen(true)}
            />
          </>
        )}

        {meta.touched && meta.error && (
          <p className="inp-error">{meta.error}</p>
        )}
      </div>
      {isOpen && (
        <ModalUpload
          handleUpload={handleUpload}
          headerText="Wgraj etykietę markową (.jpg, .png)"
          accept="image/*"
          handleClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default ImageField;
